import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { onA11yKeyDown } from '../../utils/a11y/onA11yKeyDown.js';
import { KeyboardKey } from '../../constants/keyboard.js';
import { getTestId } from '../../utils/testId.js';
import Divider from '../Divider/Divider.js';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "cell": "web_ui__Cell__cell",
  "link": "web_ui__Cell__link",
  "content": "web_ui__Cell__content",
  "prefix": "web_ui__Cell__prefix",
  "prefix-center": "web_ui__Cell__prefix-center",
  "heading": "web_ui__Cell__heading",
  "title": "web_ui__Cell__title",
  "stretched": "web_ui__Cell__stretched",
  "body": "web_ui__Cell__body",
  "subtitle": "web_ui__Cell__subtitle",
  "narrow-cell": "web_ui__Cell__narrow-cell",
  "suffix": "web_ui__Cell__suffix",
  "align-top": "web_ui__Cell__align-top",
  "validation": "web_ui__Cell__validation",
  "default": "web_ui__Cell__default",
  "tight": "web_ui__Cell__tight",
  "narrow": "web_ui__Cell__narrow",
  "wide": "web_ui__Cell__wide",
  "navigating": "web_ui__Cell__navigating",
  "is-active": "web_ui__Cell__is-active",
  "highlighted": "web_ui__Cell__highlighted",
  "with-chevron": "web_ui__Cell__with-chevron",
  "primary": "web_ui__Cell__primary",
  "amplified": "web_ui__Cell__amplified",
  "muted": "web_ui__Cell__muted",
  "success": "web_ui__Cell__success",
  "warning": "web_ui__Cell__warning",
  "expose": "web_ui__Cell__expose",
  "transparent": "web_ui__Cell__transparent",
  "inverseExperimental": "web_ui__Cell__inverseExperimental",
  "successLightExperimental": "web_ui__Cell__successLightExperimental",
  "calypsoLightExperimental": "web_ui__Cell__calypsoLightExperimental",
  "disabled": "web_ui__Cell__disabled",
  "clickable": "web_ui__Cell__clickable",
  "divider": "web_ui__Cell__divider"
};

var Styling = /*#__PURE__*/function (Styling) {
  Styling["Default"] = "default";
  Styling["Tight"] = "tight";
  Styling["Narrow"] = "narrow";
  Styling["Wide"] = "wide";
  return Styling;
}({});
var Type = /*#__PURE__*/function (Type) {
  Type["Navigating"] = "navigating";
  return Type;
}({});
var cssClasses = classNames.bind(styles);
var Cell = function Cell(_ref) {
  var _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? Styling.Default : _ref$styling,
    theme = _ref.theme,
    type = _ref.type,
    chevron = _ref.chevron,
    clickable = _ref.clickable,
    disabled = _ref.disabled,
    highlighted = _ref.highlighted,
    fullWidthTitle = _ref.fullWidthTitle,
    prefix = _ref.prefix,
    title = _ref.title,
    suffix = _ref.suffix,
    subtitle = _ref.subtitle,
    body = _ref.body,
    children = _ref.children,
    validation = _ref.validation,
    url = _ref.url,
    urlProps = _ref.urlProps,
    role = _ref.role,
    id = _ref.id,
    testId = _ref.testId,
    tabIndex = _ref.tabIndex,
    aria = _ref.aria,
    divider = _ref.divider,
    alignSuffixTop = _ref.alignSuffixTop,
    _ref$centerPrefix = _ref.centerPrefix,
    centerPrefix = _ref$centerPrefix === void 0 ? false : _ref$centerPrefix,
    onClick = _ref.onClick;
  var suffixClasses = cssClasses(styles.suffix, _defineProperty({}, styles['align-top'], alignSuffixTop));
  var prefixClasses = cssClasses(styles.prefix, _defineProperty({}, styles['prefix-center'], centerPrefix));
  var handleKeydown = function handleKeydown(event) {
    onA11yKeyDown(event, {
      keys: [KeyboardKey.Space, KeyboardKey.Enter]
    });
  };
  var getRole = function getRole() {
    if (role) return role;
    if (clickable) return 'button';
    return type === Type.Navigating ? 'button' : 'presentation';
  };
  var getTabIndex = function getTabIndex() {
    if (tabIndex !== undefined) return tabIndex;
    if (clickable) return 0;
    return type === Type.Navigating ? 0 : undefined;
  };
  var renderHeading = function renderHeading() {
    var titleClass = cssClasses(styles.title, _defineProperty(_defineProperty({}, styles.stretched, fullWidthTitle), styles['narrow-cell'], !!subtitle));
    var subtitleClass = cssClasses(styles.subtitle, _defineProperty({}, styles['narrow-cell'], !!subtitle));
    if (!title && !subtitle) return null;
    return /*#__PURE__*/jsxs("div", {
      className: styles.heading,
      children: [title ? /*#__PURE__*/jsx("div", {
        className: titleClass,
        "data-testid": getTestId(testId, 'title'),
        children: title
      }) : null, subtitle ? /*#__PURE__*/jsx("div", {
        className: subtitleClass,
        "data-testid": getTestId(testId, 'subtitle'),
        children: subtitle
      }) : null]
    });
  };
  var renderContent = function renderContent() {
    var content = body || children;
    return /*#__PURE__*/jsxs(Fragment, {
      children: [prefix ? /*#__PURE__*/jsx("div", {
        className: prefixClasses,
        "data-testid": getTestId(testId, 'prefix'),
        children: prefix
      }) : null, /*#__PURE__*/jsxs("div", {
        className: styles.content,
        children: [renderHeading(), content ? /*#__PURE__*/jsx("div", {
          className: styles.body,
          "data-testid": getTestId(testId, 'content'),
          children: content
        }) : null, validation ? /*#__PURE__*/jsx("div", {
          className: styles.validation,
          "data-testid": getTestId(testId, 'validation'),
          children: validation
        }) : null]
      }), suffix ? /*#__PURE__*/jsx("div", {
        className: suffixClasses,
        "data-testid": getTestId(testId, 'suffix'),
        children: suffix
      }) : null, divider ? /*#__PURE__*/jsx(Divider, {
        className: styles.divider
      }) : null]
    });
  };
  var cellClass = cssClasses(styles.cell, styling, theme, type, {
    'with-chevron': chevron && type === 'navigating',
    highlighted: highlighted,
    disabled: disabled,
    clickable: clickable,
    link: url
  });
  var linkProps = _objectSpread(_objectSpread(_objectSpread({}, urlProps), aria), {}, {
    id: id,
    className: cssClasses(cellClass, urlProps === null || urlProps === void 0 ? void 0 : urlProps.className),
    href: url,
    onClick: onClick,
    'data-testid': testId
  });
  var cellProps = _objectSpread(_objectSpread({}, aria), {}, {
    id: id,
    className: cellClass,
    onClick: onClick,
    onKeyDown: onClick ? handleKeydown : undefined,
    role: getRole(),
    tabIndex: getTabIndex(),
    'data-testid': testId
  });
  return url ? /*#__PURE__*/jsx("a", _objectSpread(_objectSpread({}, linkProps), {}, {
    children: renderContent()
  })) : /*#__PURE__*/jsx("div", _objectSpread(_objectSpread({}, cellProps), {}, {
    children: renderContent()
  }));
};
Cell.Styling = Styling;
Cell.Type = Type;

export { Styling, Type, Cell as default };
//# sourceMappingURL=Cell.js.map
